import React from "react";
import {Dropdown} from "primereact/dropdown";
import {useTranslate} from "../../../system/useTranslate";
import InputLabel from "../../../system/components/input-label";

export const MISSION_PARENT = "mission";
export const MAX_ROOT_GOALS = 3;

export function isActiveGoal(goal) {
    return !goal?.archivedAt && goal?.goalStatus !== "archived";
}

export function isRootGoal(goal) {
    return !goal?.parentGoal?.id && !goal?.parentGoal?.documentId && !goal?.isOrphan;
}

// ids of the goal itself and every goal below it (a goal cannot become its own parent)
export function goalAndDescendantIds(goals = [], goalId) {
    const ids = new Set([String(goalId)]);
    let grew = true;
    while (grew) {
        grew = false;
        goals.forEach((item) => {
            const parentId = item?.parentGoal?.id;
            if (parentId !== undefined && ids.has(String(parentId)) && !ids.has(String(item.id))) {
                ids.add(String(item.id));
                grew = true;
            }
        });
    }
    return ids;
}

/**
 * Searchable, mandatory parent picker: the organization mission or an existing active goal.
 * `excludeIds` hides goals that cannot be chosen, `includeMission=false` hides the mission option.
 */
function GoalParentSelect({value, onChange, goals = [], excludeIds, includeMission = true, invalid = false, required = false}) {
    const translate = useTranslate();
    const activeGoals = (goals || []).filter(isActiveGoal);
    const rootCount = activeGoals.filter(isRootGoal).length;
    const options = [
        ...(includeMission ? [{
            label: translate("goal-parent-mission"),
            value: MISSION_PARENT,
            disabled: rootCount >= MAX_ROOT_GOALS,
        }] : []),
        ...activeGoals
            .filter((goal) => !excludeIds || !excludeIds.has(String(goal.id)))
            .map((goal) => ({label: goal.title, value: goal.id})),
    ];
    return(
        <div className="flex flex-column gap-1">
            <InputLabel require={required} label={translate("goal-parent")}>
                <Dropdown
                    className={`w-full text-xs ${invalid ? "p-invalid" : ""}`}
                    panelClassName="rtl text-xs goal-parent-panel"
                    options={options}
                    optionLabel="label"
                    optionValue="value"
                    optionDisabled="disabled"
                    filter
                    showClear
                    filterPlaceholder={translate("goal-parent-search")}
                    emptyFilterMessage={translate("goal-parent-empty")}
                    placeholder={translate("goal-parent-placeholder")}
                    value={value ?? null}
                    onChange={(e) => onChange?.(e.value)}
                />
            </InputLabel>
            {invalid && <small className="p-error text-2xs">{translate("goal-parent-required")}</small>}
        </div>
    )
}

export default GoalParentSelect;
